import { Box, CircularProgress, Typography } from '@mui/material';

interface Props {
  label?: string;
  minHeight?: number | string;
}

export function LoadingState({ label = 'Loading…', minHeight = 240 }: Props) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'grid',
        placeItems: 'center',
        minHeight,
        gap: 2,
      }}
    >
      <CircularProgress size={32} />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}
